import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import { rejectionReasonAdminContext } from "../../../context/Admin/RejectionReasonAdminContext/RejectionReasonAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const RejectionReasonAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    rejectionReasonItems,
    rejectionReason,
    id,
    reason,
    setReason,
    isShowModal,
    isShowDetailsModal,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetRejectionReasonItemList,
    handleCreateRejectionReasonItem,
    handleEditRejectionReasonItem,
    handleDeleteRejectionReasonItem,
  } = useContext(rejectionReasonAdminContext);

  useEffect(() => {
    handleGetRejectionReasonItemList();
  }, [pageNumber, limit]);

  return (
    <>
      <SiteTitle title="آیتم های دلایل رد" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "آیتم های دلایل رد", type: "a" },
        ]}
        title="لیست آیتم های دلایل رد"
      />

      <CardLayout>
        {permission.rejection_reasons_create && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(rejectionReasonItems) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>توضیحات</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rejectionReasonItems.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.id}</td>
                    <td>{_item.reason}</td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() => handleShowDetailsModal(_item)}
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      {permission.rejection_reasons_update && (
                        <button
                          onClick={() => handleShowModal(_item)}
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.rejection_reasons_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteRejectionReasonItem(_item.id),
                              `آیا از حذف آیتم دلایل رد ${_item.id} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} آیتم دلایل رد`}
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={
            id ? handleEditRejectionReasonItem : handleCreateRejectionReasonItem
          }
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="reason">توضیحات</label>
              <textarea
                id="reason"
                name="reason"
                className="form-control"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          </div>
          <hr />
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات آیتم دلایل رد"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{rejectionReason.id}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{rejectionReason.reason}</p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default RejectionReasonAdmin;
